export default __webpack_public_path__ + "static/media/h1b1.80850142.png";